// extracted by mini-css-extract-plugin
export var equalColumn = "_hu-0";